/* EFP Graphics — Full Custom configurator: keeps the customer's choices across a page reload.
A reload can come from many places: the customer refreshing, a phone reclaiming the tab's memory, the
browser's back button, Zepto reloading after it repaired the cart, or Shopify's theme preview reloading
when a theme file changes. Whatever caused it, the design should still be there.
The choices are stored in sessionStorage (this tab only, gone when the tab closes), and after a reload they
are put back through the same controls the customer used: the bike selector and Zepto's own swatches, lists
and text fields. Nothing is restored after a successful add to cart, after "Start over", or when the stored
state is older than six hours. An uploaded photo cannot be stored and has to be added again.
This file is independent of efp-configurator.js; without it the configurator works as before. */
(function () {
'use strict';
var KEY = 'efp-cfg-keep:' + location.pathname, MAX_AGE = 6 * 3600 * 1000;
var BIKE = ['pplr-category', 'pplr-brand', 'pplr-model', 'pplr-year'];
var form = null, touched = false, busy = false, timer = null;

function box() { try { return window.sessionStorage; } catch (err) { return null; } }
function read() {
try { var raw = box().getItem(KEY), s = raw ? JSON.parse(raw) : null; return s && s.v === 1 && Date.now() - s.t < MAX_AGE ? s : null; } catch (err) { return null; }
}
function write(s) { try { box().setItem(KEY, JSON.stringify(s)); } catch (err) {} }
function clear() { try { box().removeItem(KEY); } catch (err) {} }
function fire(node, types) { types.forEach(function (t) { node.dispatchEvent(new Event(t, { bubbles: true })); }); }
function isBike(w) {
if (!document.body.classList.contains('efp-bike-on')) return false;
var c = ' ' + w.className + ' ';
for (var i = 0; i < BIKE.length; i++) if (c.indexOf(' ' + BIKE[i]) > -1) return true;
return false;
}
/* Zepto's fields as the customer sees them: no linked copies of another view, no static layers. */
function fields() {
var out = [], all = form.querySelectorAll('.product-personalizer .pplr-wrapper');
for (var i = 0; i < all.length; i++) {
var w = all[i];
if (w.classList.contains('p_h_d_p') || w.classList.contains('cstmfy_static') || isBike(w)) continue;
var named = w.querySelector('[name^="properties["]');
if (!named || named.type === 'file' || named.disabled) continue;
out.push({ w: w, input: named, name: named.getAttribute('name') });
}
return out;
}
function comboText(key) {
var v = document.querySelector('#efp-combo-' + key + '-b .efp-combo__val');
return v && !v.classList.contains('is-placeholder') ? v.textContent.trim() : '';
}
function snapshot() {
var cat = document.querySelector('.efp-cat[aria-checked="true"]'), other = document.getElementById('efp-other-i');
var otherOn = other && other.closest('.efp-other') && !other.closest('.efp-other').hidden;
return {
v: 1, t: Date.now(),
bike: { cat: cat ? cat.getAttribute('data-val') : '', brand: comboText('brand'), model: comboText('model'), year: comboText('year'), other: otherOn ? other.value : '' },
f: fields().map(function (x) { return [x.name, String(x.input.value)]; }),
step: form.getAttribute('data-efp-step') || '1',
view: window.pplr_current_view || ''
};
}
function save() {
if (busy || !touched || !form) return;
var old = read(), s = snapshot();
if (old && old.n) { s.n = old.n; s.nt = old.nt; }
write(s);
}
function saveSoon() { clearTimeout(timer); timer = setTimeout(save, 400); }

/* ---------- putting the choices back ---------- */
function setField(x, want) {
if (String(x.input.value) === want) return false;
var i, id, sw = x.w.querySelectorAll('.pplr-swatch-element');
if (sw.length) {
for (i = 0; i < sw.length; i++) {
id = sw[i].getAttribute('data-val') || sw[i].getAttribute('data-name');
if (id === want) { if (!sw[i].classList.contains('selected')) sw[i].click(); return true; }
}
return false;
}
var items = x.w.querySelectorAll('.pplr-selecter-item[data-name]');
if (items.length) {
for (i = 0; i < items.length; i++) if (items[i].getAttribute('data-name') === want) { items[i].click(); return true; }
return false;
}
if (x.input.tagName === 'SELECT') {
for (i = 0; i < x.input.options.length; i++) if (x.input.options[i].value === want) { x.input.value = want; fire(x.input, ['change']); return true; }
return false;
}
if (x.input.tagName === 'TEXTAREA' || x.input.type === 'text') {
var proto = x.input.tagName === 'TEXTAREA' ? HTMLTextAreaElement.prototype : HTMLInputElement.prototype;
Object.getOwnPropertyDescriptor(proto, 'value').set.call(x.input, want);
fire(x.input, ['input', 'change']);
return true;
}
return false;
}
function pick(key, text) {
var b = document.getElementById('efp-combo-' + key + '-b');
if (!b || b.disabled || !text) return false;
if (comboText(key) === text) return true;
if (b.getAttribute('aria-expanded') !== 'true') b.click();
var list = document.querySelectorAll('#efp-combo-' + key + '-p [role=option]');
for (var i = 0; i < list.length; i++) {
var span = list[i].querySelector('span');
if (span && span.textContent.trim() === text) { list[i].click(); return true; }
}
if (b.getAttribute('aria-expanded') === 'true') b.click();
return false;
}
function restore(s, done) {
var steps = [], bike = s.bike || {}, hasBike = !!document.getElementById('efp-bike');
if (hasBike && bike.cat) {
steps.push([function () { var c = document.querySelector('.efp-cat[data-val="' + bike.cat.replace(/"/g, '') + '"]'); if (c && c.getAttribute('aria-checked') !== 'true') c.click(); }, 450]);
steps.push([function () { pick('brand', bike.brand); }, 350]);
steps.push([function () { pick('model', bike.model); }, 350]);
if (bike.other) steps.push([function () {
var o = document.getElementById('efp-other-i');
if (!o || o.closest('.efp-other').hidden) return;
Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set.call(o, bike.other);
fire(o, ['input']);
}, 500]);
steps.push([function () { pick('year', bike.year); if (document.activeElement && document.activeElement.blur) document.activeElement.blur(); }, 500]);
}
(s.f || []).forEach(function (pair) {
steps.push([function () {
var list = fields();
for (var i = 0; i < list.length; i++) if (list[i].name === pair[0]) return setField(list[i], pair[1]);
return false;
}, 220]);
});
steps.push([function () {
var b = document.querySelectorAll('.efp-step')[(parseInt(s.step, 10) || 1) - 1];
if (b && form.getAttribute('data-efp-step') !== String(s.step)) b.click();
}, 300]);
steps.push([function () {
var v = s.view && document.querySelector('.efp-vs__btn[data-view="' + s.view + '"]');
if (v && window.pplr_current_view !== s.view) v.click();
}, 300]);
(function next(i) {
if (i >= steps.length) { done(); return; }
var changed = false;
try { changed = steps[i][0]() !== false; } catch (err) { if (window.console) console.warn('EFP keep: step skipped', err); }
setTimeout(function () { next(i + 1); }, changed ? steps[i][1] : 30);
})(0);
}
function notice() {
var host = document.querySelector('.efp-step-intro');
if (!host || host.querySelector('.efp-kept')) return;
var p = document.createElement('p');
p.className = 'efp-kept';
p.setAttribute('role', 'status');
p.style.cssText = 'margin:10px 0 0;font-size:13px;line-height:1.4;color:#6b6b72';
p.appendChild(document.createTextNode('We put your design back after the page reloaded. '));
var b = document.createElement('button');
b.type = 'button';
b.textContent = 'Start over';
b.style.cssText = 'appearance:none;-webkit-appearance:none;border:0;background:none;padding:0;margin:0;font:inherit;font-weight:700;color:#0f0f10;text-decoration:underline;cursor:pointer';
b.addEventListener('click', function () { busy = true; clear(); location.reload(); });
p.appendChild(b);
host.appendChild(p);
}

function watch() {
var mark = function (e) {
if (busy || !e.isTrusted) return;
var t = e.target;
if (t && t.closest && (t.closest('form.pplr_atc_form') || t.closest('.efp-bike') || t.closest('.efp-vs') || t.closest('.efp-steps'))) { touched = true; saveSoon(); }
};
['click', 'input', 'change'].forEach(function (type) { document.addEventListener(type, mark, true); });
window.addEventListener('pagehide', function () { clearTimeout(timer); save(); });
window.addEventListener('beforeunload', function () { clearTimeout(timer); save(); });
/* Zepto announces a finished add to cart; the next visit then starts clean. */
window.addEventListener('pplrAddToCartCompleted', function () { busy = true; clearTimeout(timer); clear(); });
}
function start(tries) {
tries = tries || 0;
form = document.querySelector('form.pplr_atc_form');
var ready = form && document.body.classList.contains('efp-cfg-on') && document.querySelector('.hdt-product__media.pplr canvas') && typeof window.pplr_hide_duplicate === 'function';
if (!ready) { if (tries < 120) setTimeout(function () { start(tries + 1); }, 250); return; }
watch();
var s = read();
if (!s) return;
/* Never loop: at most three restores within two minutes. */
var recent = s.nt && Date.now() - s.nt < 120000 ? (s.n || 0) : 0;
if (recent >= 3) { clear(); return; }
s.n = recent + 1; s.nt = Date.now(); write(s);
busy = true;
setTimeout(function () {
restore(s, function () {
setTimeout(function () { busy = false; touched = true; save(); notice(); }, 900);
});
}, 400);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { start(); });
else start();
})();
